import React, { memo, useCallback, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Text from 'components/core/Text';
import { updateUser } from 'actions/user';
import { ToggleRow, StyledToggle } from './styles';

const ReminderSelect = ({ isWeekly }) => {
  const userId = useSelector((state) => state.user?.id);
  const userSettings = useSelector((state) => state.user?.settings);
  const settingsKey = useMemo(() => (isWeekly ? 'weeklyReminder' : 'reminder'), [isWeekly]);
  const selectedOption = useMemo(
    () => userSettings?.[settingsKey] || false,
    [userSettings, settingsKey],
  );

  const dispatch = useDispatch();
  const handleChange = useCallback(() => {
    dispatch(
      updateUser({
        data: {
          id: userId,
          settings: {
            ...userSettings,
            [settingsKey]: !selectedOption,
          },
        },
      }),
    );
  }, [dispatch, selectedOption, settingsKey, userId, userSettings]);

  const title = useMemo(() => (isWeekly ? 'Weekly Schedule' : 'Daily Reminder'), [isWeekly]);

  const message = useMemo(
    () =>
      isWeekly
        ? 'Get a weekly schedule of all your programs in your inbox every Sunday.'
        : `We'll send you a reminder email at 5am the day you're scheduled.`,
    [isWeekly],
  );

  return (
    <>
      <ToggleRow>
        <Text variant="sectionHeader" tag="h4" weight="normal">
          {title}
        </Text>
        <StyledToggle checked={selectedOption} onChange={handleChange} aria-label={title} />
      </ToggleRow>
      <Text variant="textSmall" pt={2}>
        {message}
      </Text>
    </>
  );
};

export default memo(ReminderSelect);
